
import React, { useEffect, useState, useCallback } from 'react';
import { getReport, getContractEvents, getAnalytics } from 'api/actions/reports';
import { enUS as en, es, de, ptBR as pt } from 'react-date-range/dist/locale';
import { defaultInputRanges, defaultStaticRanges } from './Ranges';
import { DateRangePicker } from 'react-date-range';
import useDebounce from 'hooks/useDebounce';
import { parseDate, downloadFile } from 'utils';
import { fetcher } from 'api/client';
import { getFilters } from 'api/actions/users';
import { useTranslation } from 'react-i18next';
import Pagination from 'components/Shared/Paginator';
// import TimeLine from "react-gantt-timeline";
import { Badge, Table, Input, Row, Col, Container, Nav, Navbar, Form, Spinner, Card, CardHeader, CardBody, CardDeck, CustomInput, InputGroup, InputGroupAddon } from 'reactstrap';
import { useMutation, useQuery } from 'react-query';
import Select from 'react-select';
import clsx from 'clsx';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'
import {
    RadialChart,
    LabelSeries,
    makeVisFlexible,
    ChartLabel
} from 'react-vis';
import CreatableSelect from 'react-select/creatable';
import bootbox from 'components/Modals/Bootbox';
import { LABEL_STYLE, config, colorRanges } from './ReportConfig';
import {
    ReportProvider,
    useReport,
    useReportState,
    useReportDispatch,
    CHANGE_STATUS,
    SET_PROPERTIES,
    CHANGE_ID,
    CHANGE_MEMBERS,
    CHANGE_CREATOR,
    CHANGE_GROUPS,
    CHANGE_IS_APPLICATION,
    NEXT_PAGE,
    PREVIOUS_PAGE,
    GO_TO_PAGE,
    CHANGE_DATE,
    CHANGE_NAME,
    CHANGE_PARTICIPANT_NAME,
    CHANGE_EXTERNALID,
    RESET,
    CHANGE_DELETED
} from 'context/report';
import { MainHeader } from 'components/Shared/MainHeader';
import { useProfileAbility, useProfileState } from 'context/profile';

const lang = { es, en, pt, de };

function MainTable({ report = {}, isLoading }) {

    const reportDispatch = useReportDispatch();

    const reportState = useReportState();

    const nextPage = () => reportDispatch({ type: NEXT_PAGE })

    const previousPage = () => reportDispatch({ type: PREVIOUS_PAGE })

    const onPageClick = (page) => reportDispatch({ type: GO_TO_PAGE, page })


    // const { data: events } = useQuery('devents', (id) => fetcher(getContractEvents(id)))

    const getEvents = (payload) => console.log(payload)

    const { mutate: mutateDownload } = useMutation((payload) => fetcher(getReport('dreport', payload)), {
        onSuccess: (data) => {
            downloadFile({
                suffix: new Date().getTime(),
                name: 'Report',
                ext: 'csv',
                blob: new Blob(['\ufeff', data])
            })();
        }
    });

    const downloadCSV = async () => {
        if (report.total < 1) return bootbox.alert(t('reports.must_select_one'));
        const exportVariables = await bootbox.confirm({
            message: t('reports.include_variables'),
            buttons: {
                confirm: {
                    label: 'Si'
                },
                cancel: {
                    label: 'No'
                }
            }
        });
        
        mutateDownload({ ...reportState, exportReport: true, exportVariables })
    }

    const { t } = useTranslation();
    return (
        <Card className="rounded-lg" >
            <CardBody>
                <div className="report-header p-3">
                    {isLoading && <Spinner size="sm" />}{' '}
                    <span className="font-weight-bold">{t('reports.documents')} ({report?.total})</span>

                    <span className="float-right pointer font-weight-bold ml-3" onClick={downloadCSV}>
                        <i className="fas fa-cloud-download-alt mr-1"></i>
                        {t('reports.export')}
                    </span>


                </div>

                <Table responsive hover className="reportTable">
                    <thead>
                        <tr>
                            <th className="text-nowrap text-center"></th>
                            <th className="text-nowrap text-center">Id</th>
                            <th className="text-nowrap text-center">{t('reports.externalId')}</th>
                            <th className="text-nowrap text-center">{t('reports.name')}</th>
                            <th className="text-nowrap text-center">{t('reports.created')}</th>
                            <th className="text-nowrap text-center">{t('reports.user')}</th>
                            <th className="text-nowrap text-center">{t('reports.creator')}</th>
                            <th className="text-nowrap text-center">{t('reports.type')}</th>
                            <th className="text-nowrap text-center">{t('reports.template')}</th>
                            <th className="text-nowrap text-center">{t('reports.group')}</th>
                            <th className="text-nowrap text-center">{t('reports.application')}</th>
                            <th className="text-nowrap text-center">{t('reports.deleted')}</th>
                            <th className="text-nowrap text-center">{t('reports.status')}</th>
                            <th className="text-nowrap text-center">{t('reports.link')}</th>
                            <th className="text-nowrap text-center">{t('reports.participants')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {report.docs?.length ?
                            report.docs.map(r => (
                                <tr key={r._id}>
                                    <td className="text-center align-middle"></td>
                                    <td className="text-center align-middle">{r.documentId}</td>
                                    <td className="text-center align-middle">{r.externalId || '-'}</td>
                                    <td className="text-center align-middle" onClick={() => getEvents(r._id)}>{r.name}</td>
                                    <td className="text-center align-middle">{parseDate(r.createdAt, 'P')}</td>
                                    <td className="text-center align-middle">{r.user?.givenName} {r.user?.familyName}</td>
                                    <td className="text-center align-middle">{r.creator?.givenName} {r.creator?.familyName}</td>
                                    <td className="text-center align-middle">{r.type?.name}</td>
                                    <td className="text-center align-middle">{r.template?.name}</td>
                                    <td className="text-center align-middle">{r.group?.name}</td>
                                    <td className="text-center align-middle">{r.isApplication ? t('reports.yes') : t('reports.no')}</td>
                                    <td className="text-center align-middle">{r.deleted ? t('reports.yes') : t('reports.no')}</td>
                                    <td className="text-center align-middle"><Badge color="success" className="success-pill d-inline" pill>{t(`contracts.status.${r.status}`)}</Badge></td>
                                    <td className="text-center align-middle"><a target="_blank" rel="noreferrer" href={`${String(window.location.origin).toLowerCase()}/sign/${r._id}`}>{' '}  <i className="fas fa-link"> </i></a></td>
                                    <td>
                                        {
                                            r.participants?.map((p) => (
                                                <p>
                                                    {p.email} {p.status ? `- ${t('contracts.status.' + p.status)}` : ''}
                                                </p>
                                            ))
                                        }
                                    </td>
                                </tr>
                            ))
                            :
                            <tr className="text-center"><td colSpan="14">{t('reports.no_documents')}</td></tr>
                        }
                    </tbody>

                </Table>
                <div className="text-center border-top bg-white mb-3 sticky-bottom">
                    <Pagination
                        page={reportState.page}
                        currentPage={report.page}
                        total={report.pages || 1}
                        isDisabled={false}
                        onNextPage={nextPage}
                        onPrevPage={previousPage}
                        onPageClick={onPageClick}
                    />
                </div>
            </CardBody>
        </Card>
    )
}

function ReportView({ report = {}, analytics = {}, isLoading }) {

    const { data: filters = {}, isFetching: isFetchingFilter } = useQuery('filters', () => fetcher(getFilters()));

    const [reportState, reportDispatch] = useReport();

    const [showCalendar, setshowCalendar] = useState(false);

    const { t, i18n } = useTranslation();

    const handleChangeId = (value) => reportDispatch({ type: CHANGE_ID, value })

    const handleChangeMembers = (value) => reportDispatch({ type: CHANGE_MEMBERS, value })

    const handleChangeCreator = (value) => reportDispatch({ type: CHANGE_CREATOR, value })

    const handleChangeGroups = (value) => reportDispatch({ type: CHANGE_GROUPS, value })

    const handleChangeStatus = (value) => reportDispatch({ type: CHANGE_STATUS, value })

    const handleChangeHeader = (node) => reportDispatch({ type: SET_PROPERTIES, header: t('contracts.status.' + node.name) + ' ' + node.total })

    const handleChangeName = (e) => reportDispatch({ type: CHANGE_NAME, name: e.target.value })

    const handleChangeParticipantName = (e) => reportDispatch({ type: CHANGE_PARTICIPANT_NAME, participantName: e.target.value })

    const handleChangeExternalId = (e) => reportDispatch({ type: CHANGE_EXTERNALID, externalId: e.target.value })

    const handleReset = () => reportDispatch({ type: RESET })


    const handleChangeIsApplication = () => reportDispatch({ type: CHANGE_IS_APPLICATION })

    const handleChangeDeleted = () => reportDispatch({ type: CHANGE_DELETED })

    const updateRange = ({ selection: { endDate, startDate, key } }) => reportDispatch({ type: CHANGE_DATE, startDate, endDate, key });

    useEffect(() => {
        const total = report.status?.reduce((acc, status) => acc += status.total, 0);
        reportDispatch({ type: SET_PROPERTIES, header: total ? t('contracts.status.total') + ' ' + total : '', pages: Number(report.pages) });
    }, [report.pages, report.status, reportDispatch, t])

    const handleShowCalendar = () => setshowCalendar(!showCalendar)

    const handleHideCalendar = () => {
        if (showCalendar) setshowCalendar(false)
    }
    const FlexRadialChart = makeVisFlexible(RadialChart);

    return (
        <>
            {showCalendar && <div className="pointer h-100 w-100" style={{ position: 'absolute', zIndex: 100, marginLeft: '-100px' }} onClick={handleHideCalendar}></div>}

            <MainHeader title="reports.title">
                <>
                    <div className="pointer p-2 text-underline" onClick={handleShowCalendar}>
                        {/* <label>{t('reports.period')}:</label>{' '} */}
                        <u>
                            <span className="pointer">{parseDate(new Date(reportState?.startDate).toISOString(), 'PP')}</span>{' - '}
                            <span className="pointer">{parseDate(new Date(reportState?.endDate).toISOString(), 'PP')}</span>{' '}
                            {showCalendar ?
                                <i className="fas fa-caret-down"></i> :
                                <i className="fas fa-caret-right"></i>
                            }
                        </u>
                    </div>
                    <div className={clsx('card-shadow', showCalendar || 'd-none')} style={{ position: 'absolute', zIndex: 1000, top: 40, right: 0 }}>
                        <DateRangePicker
                            onChange={item => updateRange(item)}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={1}
                            ranges={[{ endDate: reportState.endDate, startDate: reportState.startDate, key: reportState.key }]}
                            direction="vertical"
                            locale={lang[i18n.language]}
                            // fixedHeight={true}
                            staticRanges={defaultStaticRanges.map((input) => ({ ...input, label: t('calendar.' + input.label) }))}
                            inputRanges={defaultInputRanges.map((input) => ({ ...input, label: t('calendar.' + input.label) }))}
                        />
                    </div>
                </>
            </MainHeader>
            <Container fluid>
                <Row>
                    <Col md="6" sm="12" lg="4" className="text-center">
                        <Form>
                            <Row form>
                                <Col className="mb-2" md="6" >
                                    <Select
                                        styles={reactSelectStyles}
                                        placeholder={t('reports.users')}
                                        noOptionsMessage={() => t('common.no_options')}
                                        options={isFetchingFilter ? [] : (filters?.members || [])}
                                        onChange={handleChangeMembers}
                                        isMulti />
                                </Col>
                                <Col className="mb-2" md="6">
                                    <Select
                                        styles={reactSelectStyles}
                                        placeholder={t('reports.creator')}
                                        noOptionsMessage={() => t('common.no_options')}
                                        options={isFetchingFilter ? [] : (filters?.members || [])}
                                        onChange={handleChangeCreator}
                                        isMulti />
                                </Col>
                                <Col className="mb-2" md="6">
                                    <Select
                                        styles={reactSelectStyles}
                                        placeholder={t('reports.groups')}
                                        noOptionsMessage={() => t('common.no_options')}
                                        options={isFetchingFilter ? [] : (filters?.groups || [])}
                                        onChange={handleChangeGroups}
                                        isMulti />
                                </Col>
                                <Col className="mb-2" md="6">
                                    <CreatableSelect
                                        styles={reactSelectStyles}
                                        isMulti={true}
                                        isClearable
                                        noOptionsMessage={() => t('report.add_options')}
                                        onChange={handleChangeId}
                                        placeholder={t('reports.id_filter')}
                                        formatCreateLabel={(v) => `${t('reports.add_id')}... ${v}`}
                                    />
                                </Col>
                                <Col className="mb-2" md="12">
                                    <Select
                                        styles={reactSelectStyles}
                                        isMulti={true}
                                        isClearable
                                        options={isFetchingFilter || !filters?.status?.length ? [] : filters?.status.map(s => ({ value: s, label: t('contracts.status.' + s) }))}
                                        noOptionsMessage={() => t('report.add_options')}
                                        onChange={handleChangeStatus}
                                        placeholder={t('reports.status')}
                                        formatCreateLabel={(v) => `${t('reports.add_status')}... ${v}`}
                                    />
                                </Col>
                                <Col className="mb-2" md="12">
                                    <Input
                                        disabled={reportState.disableParticipantName}
                                        onChange={handleChangeParticipantName}
                                        placeholder={t('reports.participant_name')}
                                        value={reportState.participantName}
                                    />
                                </Col>
                                <Col className="mb-2" md="6">
                                    <Input
                                        onChange={handleChangeName}
                                        placeholder={t('reports.document_name')}
                                    />
                                </Col>
                                <Col className="mb-3" md="6">
                                    <Input
                                        onChange={handleChangeExternalId}
                                        placeholder={t('reports.externalId')}
                                    />
                                </Col>
                                <Col className="mb-2" md="6">
                                    <InputGroup>
                                        <CustomInput
                                            label={<>{t('reports.include_applications')}<i className="fas fa-file ml-2" ></i></>}
                                            defaultChecked={!reportState.isApplication}
                                            id="isApplication"
                                            name="isApplication"
                                            className="font-weight-bold"
                                            type="checkbox" onChange={handleChangeIsApplication} />
                                    </InputGroup>
                                </Col>
                                <Col className="mb-2" md="6">
                                    <InputGroup>



                                        <CustomInput
                                            label={<>{t('reports.include_deleted')}<i className="fas fa-trash ml-2" ></i></>}
                                            defaultChecked={reportState.deleted}
                                            id="deleted"
                                            name="deleted"
                                            className="font-weight-bold"
                                            type="checkbox" onChange={handleChangeDeleted} />
                                    </InputGroup>
                                </Col>
                                {/* <div className="col-md-12 ">
                            <button
                                className="btn btn-default btn-block"
                                onClick={handleReset}
                            >
                                {t('reports.properties.clean')}
                            </button>
                        </div> */}
                            </Row>
                        </Form>
                    </Col>

                    <Col md="6" sm="6" lg="4" className="">
                        <Card className="card-shadow rounded-lg">
                            <CardBody>
                                <span className="font-weight-bold">{t('reports.analysis')}</span>
                                <Table hover responsive size="sm" className="reportTable mt-4">
                                    <thead>
                                        <tr>
                                            <th>{t('reports.metric')}</th>
                                            <th className="text-right">{t('reports.value')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {analytics && analytics.length > 0 && analytics.map((r, index) => (
                                            <tr key={`analytics-${index}`}>
                                                <td>{t(`reports.${r.metric}`)}</td>
                                                <td className="text-right">
                                                    {r?.minutes || (r.value === 'N/A' && t('reports.no_time')) || r.value}
                                                    {(r.unit === 'percentage' && '%') || (r.unit === 'time' && r.value !== 'N/A' && ' minutos') || ''}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md="12" sm="12" lg="4" className="text-center">
                        <Card className="card-shadow rounded-lg  h-100">
                            <CardBody className=" w-100 h-100">
                                <span className="font-weight-bold">{t('reports.perStatus')}</span>
                                <div className="overflow-hidden h-100 p-4" style={{ minHeight: '205px', margin: '-20px' }}>

                                    <FlexRadialChart
                                        className={clsx(reportState.showTimeline && 'd-none')}
                                        colorRange={colorRanges}
                                        data={(report.status?.map((r, i) => ({ name: r._id, total: r.total, angle: r.total, color: i + 1, innerRadius: 0.6 }))) || []}
                                        animation="gentle"
                                        onValueMouseOver={handleChangeHeader}
                                    >
                                        <LabelSeries
                                            className="font-weight-bold"
                                            data={[{ x: 0, y: 0, label: reportState.header, style: LABEL_STYLE }]}
                                        />
                                    </FlexRadialChart>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" sm="12" lg="12" className="mt-3">
                        <MainTable report={report} isLoading={isLoading} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

function Report() {

    const { profile } = useProfileState();

    const [reportState, dispatch] = useReport();

    const [enabled, setEnabled] = useState(false);

    const ability = useProfileAbility();

    const doFetchAnalytics = useCallback(() => {
        return fetcher(getAnalytics(reportState))
    }, [reportState])

    const doFetchReport = useCallback(() => {
        return fetcher(getReport('dreport', reportState))
    }, [reportState])

    const debouncedSearchName = useDebounce(reportState.name, 500);

    const debouncedSearchParticipantName = useDebounce(reportState.participantName, 500);

    const debouncedSearchExternalId = useDebounce(reportState.externalId, 500);

    const triggers = {
        page: reportState.page,
        isApplication: reportState.isApplication,
        deleted: reportState.deleted,
        selectedCreators: reportState.selectedCreators,
        selectedUsers: reportState.selectedUsers,
        selectedGroups: reportState.selectedGroups,
        status: reportState.status,
        startDate: reportState.startDate,
        endDate: reportState.endDate,
        documentId: reportState.documentId,
        name: debouncedSearchName,
        participantName: debouncedSearchParticipantName,
        externalId: debouncedSearchExternalId
    };


    useEffect(() => {
        if (profile.email) {
            if (ability.can('VIEW_ONLY_SELF_EMAIL_REPORT')) {
                dispatch({
                    type: CHANGE_PARTICIPANT_NAME,
                    participantName: profile.email,
                    disableParticipantName: true
                });
            }
            setEnabled(true)
        }
    }, [ability, profile])

    const { data: analytics } = useQuery(['analytics', triggers], doFetchAnalytics, { keepPreviousData: true, enabled })

    const { data: report, isLoading } = useQuery(['dreport', triggers], doFetchReport, { keepPreviousData: true, enabled })

    return <ReportView
        isLoading={isLoading}
        report={report}
        analytics={analytics}
    />
}

export default function ReportMainView() {
    return (
        <ReportProvider>
            <Report />
        </ReportProvider>
    )
}